import { Link, useLocation } from 'react-router-dom';

import MenuIcon from '@material-ui/icons/Menu';
import { OpendoorLogoSvg } from '@opendoor/mosaic';

import { WEB_URL } from '../utils/constants';
import './NavigationBar.css';

interface NavItemProps {
  label: string;
  href: string;
  isExternal?: boolean;
  target?: string;
  isActive?: boolean;
}

const NavLink = (props: NavItemProps) => {
  if (props.isExternal) {
    return (
      <a
        style={{ opacity: 1, textDecoration: 'none' }}
        target={props.target}
        className={[
          'fs-7 b hover-blue4 pv-6 ph-4',
          props.isActive ? 'blue4 nav-active' : 'black',
        ].join(' ')}
        href={`${WEB_URL}${props.href}`}
      >
        {props.label}
      </a>
    );
  }

  return (
    <Link
      style={{ opacity: 1, textDecoration: 'none' }}
      className={[
        'fs-7 b hover-blue4 pv-6 ph-4',
        props.isActive ? 'blue4 nav-active' : 'black',
      ].join(' ')}
      to={props.href}
    >
      {props.label}
    </Link>
  );
};

const navBarLinks: NavItemProps[] = [
  {
    label: 'Work Orders',
    href: '/work-orders',
  },
  {
    label: 'On-Site Workers',
    href: '/vendor/on-site-workers',
    isExternal: true,
  },
  {
    label: 'Maintenance',
    href: '/vendor/maintenance',
    isExternal: true,
  },
  {
    label: 'Photos',
    href: '/vendor/photography',
    isExternal: true,
  },
  {
    label: 'Invoices',
    href: '/vendor/invoices',
    isExternal: true,
  },
  {
    label: 'External Listings',
    href: '/vendor/external-listings',
    isExternal: true,
  },
  {
    label: 'On-Site Portal',
    href: '/on-site',
    isExternal: true,
    target: '_blank',
  },
  {
    label: 'Visits',
    href: '/visits',
  },
];

const NavigationBar = () => {
  const location = useLocation();

  const activeIdx = navBarLinks.findIndex((i) => i.href === location.pathname);

  return (
    <div className="nav">
      <link rel="stylesheet" href={'https://fonts.googleapis.com/css?family=Roboto'} />
      <input type="checkbox" id="nav-check" />
      <div className="nav-header">
        <div className="nav-title">
          <OpendoorLogoSvg color="blue4" className="w-3 h-3 mr-2" />
          <Link to="/" style={{ textDecoration: 'none' }} className="blue4 fs-5 b">
            VENDOR PORTAL
          </Link>
        </div>
      </div>
      <div className="nav-btn">
        <label htmlFor="nav-check">
          <MenuIcon className="blue4" />
        </label>
      </div>

      <div className="nav-links justify-between">
        <div className="left-links">
          {navBarLinks.map((item, idx) => (
            <NavLink key={item.href} {...item} isActive={activeIdx === idx} />
          ))}
        </div>
        <div className="right-links">
          <NavLink href="/vendor-help" label="Help Center" target="_blank" />
          <NavLink href="/logout" label="Sign out" />
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
